module.exports = __webpack_public_path__ + "static/img/1aw.6ae7978d.webp";